require('./parallax.scss');
const charming = require('./charming.js')

var _requestAnimationFrame = null;

var parallax_updater = function() {
	var s = $(window).scrollTop();
	var wH = $(window).height();

	$('.page_row_background[parallax="true"]').each(function(){
		var $obj = $(this);
		var elT = $obj.offset().top;
		var elH = $obj.outerHeight();

		var begin = elT - wH;
		var end = begin + wH + elH;

		if(s>begin && s<end)
		{
			var d = (s-begin)/(end-begin) - 0.5;
			//console.log('50% '+(d*100)+'%')
			$obj.css({'background-position':'50% '+(d*100)+'%'});
		}
	});

	for(let selector in window.FloatingParallaxElementSelectors)
	{
		let param = window.FloatingParallaxElementSelectors[selector] || {};
		if(typeof param != "object" || param && typeof param.length != "undefined")
		{
			param = {H:0,V:75/2};
		}
		param.H = param && typeof param.H != "undefined" ? param.H : 0 ;
		param.V = param && typeof param.V != "undefined" ? param.V : 0 ;

		$(selector).each(function(index){

			var $obj = $(this);

			var elT = $obj.offset().top;
			var elH = $obj.outerHeight();

			// parallax partial area
			var begin = elT - wH * .75;
			var end = begin + wH * .75 + elH;

			// fullscreen area
			var screenBegin = elT - wH;
			var screenEnd = begin + wH + elH;

			//console.log(screenBegin,s,screenEnd)

			if(s>screenBegin && s<screenEnd)
			{
				var d = 2*((s-begin)/(end-begin) - 0.5);

				if(param.lettering && param.lettering.animation)
				{
					param.lettering.speed = param.lettering.speed || 1000;
					param.lettering.delay = param.lettering.delay || 100;
					if(!$obj.data('parallax-leterring-ready'))
					{
						charming(this)
						$obj.data('parallax-leterring-ready',true);
						let letters = $obj.find('[class^=char]')
						let speed = param.lettering.speed / letters.length;
						letters.addClass('char')
						setTimeout(() => {
							letters.addClass('char-animate');
						},param.lettering.delay)
						letters.each(function(i){
							if($(this).html()==' ')
								$(this).html('&nbsp;');
							$(this).attr('data-animation',param.lettering.animation)
							$(this).css({display:"inline-block",'transition-delay':(speed*i)+'ms','animation-delay':(speed*i)+'ms'});
						})
					}
				}

				//console.log(selector+':'+index+' '+d,'translate('+(d*param.H)+'%, '+(d*param.V)+'%)',$obj)
				$obj.css({transform:'translate('+(d*param.H)+'%, '+(d*param.V)+'%)'});
			}
		});
	}
}

window.FloatingParallaxElementSelectors = {};
window.addFloatingParallaxElement = function(selector,param=null){
	window.FloatingParallaxElementSelectors[selector] = param;
}

$( document ).ready(function() {
	var varWidthWindow = $(window).width();
	if(ENV_MOBILE)
		; // pas sur mobile ^^
	else
		window.setTimeout(_init, 0)
});

function _init() {
	console.log('HAPI.Parallax :: init')
	window.addEventListener('scroll', _handler)
	_handler();
}

function _handler () {
	_requestAnimationFrame(parallax_updater)
}

_requestAnimationFrame = window.requestAnimationFrame ||
						 window.webkitRequestAnimationFrame ||
						 window.mozRequestAnimationFrame ||
						 function (callback) {
							window.setTimeout(callback, 0)
						 }